import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Offer } from 'src/app/commons/models/offer.model';
import { PAGE_SIZE_OPTIONS } from 'src/app/helpers/table.helper';
import * as OfferActions from 'src/app/store/actions/offer.actions';
import { AppState } from 'src/app/store/reducers';
import * as OfferSelectors from 'src/app/store/selectors/offer.selectors';
import * as AuthSelectors from 'src/app/store/selectors/auth.selectors';

import { OfferFilters } from '../../../commons/models/offer.model';
import { OffersColumn } from '../offer-list/offer-list.component';


@Component({
  selector: 'app-offer-selection',
  templateUrl: './offer-selection.component.html',
  styleUrls: ['./offer-selection.component.scss']
})
export class OfferSelectionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();

  offers: Observable<Offer[]>;
  filters: Observable<OfferFilters>;

  @Input()
  defaultFilters: OfferFilters = {
    title: ""
  }

  displayedColumns: OffersColumn[] = ["version", "title", "businessOpportunity", "actions"];

  pageSizeOptions = PAGE_SIZE_OPTIONS;

  total: Observable<number>;
  constructor(private store$: Store<AppState>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.offers = this.store$.pipe(select(OfferSelectors.getSelectionOffers), takeUntil(this.unsubscribe$), map(dtos => dtos ? dtos.map(dto => new Offer(dto)) : null));
    this.total = this.store$.pipe(select(OfferSelectors.getTotalOffers), takeUntil(this.unsubscribe$));
    this.filters = this.store$.pipe(select(OfferSelectors.getFilters), takeUntil(this.unsubscribe$));
    if (data) {
      this.defaultFilters = data.defaultFilters;
    }
  }

  load() {
    this.store$.dispatch(OfferActions.loadSelectionOffers(
      { page: 1, perPage: this.pageSizeOptions[0], filters: this.defaultFilters }));
  }

  sortChange(sort: Sort) {
    this.store$.dispatch(OfferActions.changeSort({ order: sort.active, direction: sort.direction }));
  }

  pageChange(pageEvent: PageEvent) {
    this.store$.dispatch(OfferActions.changePage({ page: pageEvent.pageIndex + 1, size: pageEvent.pageSize }))
  }

  filtersSelectionChange(filters: OfferFilters) {
    this.store$.dispatch(OfferActions.changeSelectionFilters({ filters }));
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectOffer(offer: Offer) {
    if (offer) {
      this.store$.dispatch(OfferActions.offerSelected({ offer: offer.toDTO() }));
    }
  }

  close() {
    this.store$.dispatch(OfferActions.closeSelectionDialog())
  }
}
